import apiCall from '../../apiCall/apiCall';
import buildUrlSearchParams from '../../apiCall/buildUrlSearchParams/buildUrlSearchParams';

// This class handles any API calls related to printers.
class Printer {
  static all(data) {
    const params = buildUrlSearchParams(data);
    return apiCall('GET', 'api/printers/queues', params);
  }

  static printPackages(printerId, packageIds) {
    const params = { queueId: printerId, ids: packageIds };
    return apiCall('POST', 'api/warehouses/labels/print_packages', params);
  }

  static printPotentialPackages(printerId, jobs) {
    const params = [];
    Object.keys(jobs).forEach(id =>
      params.push({
        jobId: id,
        count: jobs[id].map(assignment => assignment.quantity).reduce((a, b) => a + b, 0),
      }),
    );

    return apiCall('POST', 'api/warehouses/labels/print_potential_packages', {
      queueId: printerId,
      packages: params,
    });
  }
}

export default Printer;
